export const ACCOUNT_LABEL_TABLE_NAME = 'AccountLabel';
export const ADDRESS_TABLE_NAME = 'Address';
export const ADMIN_COMMUNICATION_TABLE_NAME = 'AdminCommunication';
export const ADMIN_FILE_TABLE_NAME = 'AdminFile';
export const ADVERTISEMENT_TABLE_NAME = 'Advertisement';
export const AGENCY_RATE_TABLE_NAME = 'AgencyRate';
export const AGENCY_RATE_OWNER_TABLE_NAME = 'AgencyRateOwner';
export const AGENCY_RATE_STATEMENT_TABLE_NAME = 'AgencyRateStatement';
export const APPLICATION_INVOICE_TABLE_NAME = 'ApplicationInvoice';
export const APPLICATION_INVOICE_LINE_TABLE_NAME = 'ApplicationInvoiceLine';
export const APPLICATION_PLAN_TABLE_NAME = 'ApplicationPlan';
export const APPLICATION_SUBSCRIPTION_TABLE_NAME = 'ApplicationSubscription';
export const APPLICATION_SUBSCRIPTION_VARIOUS_OPERATION_TABLE_NAME = 'ApplicationSubscriptionVariousOperation';
export const APPLICATION_VARIOUS_OPERATION_TABLE_NAME = 'ApplicationVariousOperation';
export const BANK_ACCOUNT_TABLE_NAME = 'BankAccount';
export const BILLING_ITEM_TABLE_NAME = 'BillingItem';
export const BUILDING_TABLE_NAME = 'Building';
export const BUILDING_EVENT_TABLE_NAME = 'BuildingEvent';
export const BUILDING_OWNER_TABLE_NAME = 'BuildingOwner';
export const BUILDING_SITE_TABLE_NAME = 'BuildingSite';
export const CASH_EXPECTATION_TABLE_NAME = 'CashExpectation';
export const CHARGE_TABLE_NAME = 'Charge';
export const CHARGE_ENVELOPE_TABLE_NAME = 'ChargeEnvelope';
export const CHARGE_SECTION_TABLE_NAME = 'ChargeSection';
export const CHARGE_STATEMENT_TABLE_NAME = 'ChargeStatement';
export const CLIENT_TABLE_NAME = 'Client';
export const COMMUNICATION_TABLE_NAME = 'Communication';
export const COMMUNICATION_SETTINGS_PROFILE_TABLE_NAME = 'CommunicationSettingsProfile';
export const COMPANY_USER_TABLE_NAME = 'CompanyUser';
export const CONTACT_TABLE_NAME = 'Contact';
export const COUNTERPARTY_IDENTITY_TABLE_NAME = 'CounterpartyIdentity';
export const COUNTERPARTY_ROLE_TABLE_NAME = 'CounterpartyRole';
export const CREDIT_COST_TABLE_NAME = 'CreditCost';
export const CREDIT_USAGE_COST_TABLE_NAME = 'CreditUsageCost';
export const CUSTOM_FIELD_TABLE_NAME = 'CustomField';
export const CUSTOM_SUBSCRIPTION_TABLE_NAME = 'CustomSubscription';
export const DOCUMENT_CATEGORY_TABLE_NAME = 'DocumentCategory';
export const CAUSE_TABLE_NAME = 'Cause';
export const ENTITY_ALIAS_TABLE_NAME = 'EntityAlias';
export const IMPORT_RUN_TABLE_NAME = 'ImportRun';
export const DOCUMENT_EXTRACTION_TABLE_NAME = 'DocumentExtraction';
export const DOCUMENT_NUMBER_TABLE_NAME = 'DocumentNumber';
export const ENTITY_RELATION_TABLE_NAME = 'EntityRelation';
export const FEE_ARREARS_TABLE_NAME = 'FeeArrears';
export const FILE_TABLE_NAME = 'File';
export const FILTER_GROUP_TABLE_NAME = 'FilterGroup';
export const INTEGRATION_TABLE_NAME = 'Integration';
export const INTERNAL_COMMENT_TABLE_NAME = 'InternalComment';
export const INVOICE_TABLE_NAME = 'Invoice';
export const INVOICE_SETTING_TABLE_NAME = 'InvoiceSetting';
export const LEARNING_EVENT_TABLE_NAME = 'LearningEvent';
export const LEASE_TABLE_NAME = 'Lease';
export const LEASE_ACTION_HISTORY_TABLE_NAME = 'LeaseActionHistory';
export const LEASE_ADDITIONAL_CLAUSE_TABLE_NAME = 'LeaseAdditionalClause';
export const LEASE_CONTACT_TABLE_NAME = 'LeaseContact';
export const LEASE_PRICE_HISTORY_TABLE_NAME = 'LeasePriceHistory';
export const LEASE_VARIOUS_OPERATION_TABLE_NAME = 'LeaseVariousOperation';
export const MORTGAGE_TABLE_NAME = 'Mortgage';
export const NOTIFICATION_TABLE_NAME = 'Notification';
export const PAYMENT_ORDER_TABLE_NAME = 'PaymentOrder';
export const PAYMENT_BATCH_TABLE_NAME = 'PaymentBatch';
export const POSTING_TABLE_NAME = 'Posting';
export const RECONCILIATION_DECISION_TABLE_NAME = 'ReconciliationDecision';
export const RECONCILIATION_SETTING_TABLE_NAME = 'ReconciliationSetting';
export const RECURRING_PAYMENT_TEMPLATE_TABLE_NAME = 'RecurringPaymentTemplate';
export const RELEASE_NOTE_TABLE_NAME = 'ReleaseNote';
export const REPARTITION_KEY_TABLE_NAME = 'RepartitionKey';
export const REPAYMENT_STATEMENT_TABLE_NAME = 'RepaymentStatement';
export const SCHEDULE_RULE_TABLE_NAME = 'ScheduleRule';
export const SENDER_RULE_TABLE_NAME = 'SenderRule';
export const SENDING_SOURCE_TABLE_NAME = 'SendingSource';
export const SETTING_TABLE_NAME = 'Setting';
export const SIGNATURE_DOCUMENT_TABLE_NAME = 'SignatureDocument';
export const STATEMENT_TABLE_NAME = 'Statement';
export const STATEMENT_SETTING_TABLE_NAME = 'StatementSetting';
export const SUBSCRIPTION_USAGE_HISTORY_TABLE_NAME = 'SubscriptionUsageHistory';
export const TAG_TABLE_NAME = 'Tag';
export const TECHNIC_TABLE_NAME = 'Technic';
export const TECHNIC_LIBRARY_TABLE_NAME = 'TechnicLibrary';
export const TEMPLATE_TABLE_NAME = 'Template';
export const TICKET_TABLE_NAME = 'Ticket';
export const TRANSACTION_TABLE_NAME = 'Transaction';
export const TRANSACTION_RULE_TABLE_NAME = 'TransactionRule';
export const UNIT_TABLE_NAME = 'Unit';
export const UNIT_EVENT_TABLE_NAME = 'UnitEvent';
export const UNIT_INVENTORY_TABLE_NAME = 'UnitInventory';
export const UNIT_LEASE_TABLE_NAME = 'UnitLease';
export const UNIT_OWNER_TABLE_NAME = 'UnitOwner';
export const VALUATION_TABLE_NAME = 'Valuation';
export const VARIOUS_OPERATION_TABLE_NAME = 'VariousOperation';
export const VAT_RATE_TABLE_NAME = 'VatRate';

// Tier names for the workspace-scoped partition key ({tier}#{clientId}) that
// are not table names themselves. Tiers matching a table reuse its const.
export const BASIC_TIER = 'Basic';
